import { FloatingButtonEnvironmentOverrides } from '@fb/models';

export function parseFloatingButtonEnvironmentOverrides(
  value: FloatingButtonEnvironmentOverrides | string | null | undefined,
): FloatingButtonEnvironmentOverrides {
  if (value == null || value === '') {
    return {};
  }

  if (typeof value === 'string') {
    try {
      return JSON.parse(value) as FloatingButtonEnvironmentOverrides;
    } catch (e) {
      console.error('[floating-button] Invalid JSON in environmentOverrides', e);
      return {};
    }
  }

  return value;
}
